import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { putAlertasReconhecer } from './services'
import { TGetAlertasAbertos } from './types'
import { toast } from "sonner";

const initialState: any = {
  status: "",
  data: ""
}

export const actionPutAlertasReconhecer: any = createAsyncThunk<string, string>(
  "ACTION_PUT_ALERTA_RECONHECER",
  async (id) => {
    return putAlertasReconhecer(id)
  }
)

const slicePutAlertasReconhecer = createSlice({
  name: "PUT_ALERTA_RECONHECER",
  initialState,
  reducers: {
    actionResetPutAlertasReconhecer: (state) => {
      state.status = ""
      state.data = ""
    }
  },
  extraReducers: {
    [actionPutAlertasReconhecer.pending]: (state) => {
      state.status = "loading"
    },
    [actionPutAlertasReconhecer.fulfilled]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
      toast.success("Alerta reconhecido com sucesso!")
    },
    [actionPutAlertasReconhecer.rejected]: (state) => {
      state.status = "error"
      toast.error("Erro ao reconhecer alerta. Tente novamente.")
    },
  }
})

export default slicePutAlertasReconhecer.reducer
export const { actionResetPutAlertasReconhecer } =
  slicePutAlertasReconhecer.actions;